const DOMPurify = require('dompurify');

/**
 * Sanitize HTML before rendering with dangerouslySetInnerHTML.
 *
 * Eventbrite and similar APIs return HTML descriptions that must be stripped of
 * executable content (scripts, event handlers, javascript: URLs) before injection
 * into the DOM.
 *
 * @param {string|null|undefined} html - Raw HTML from an external source.
 * @returns {string} Sanitized HTML safe for dangerouslySetInnerHTML.
 */
function sanitizeHtml(html) {
  if (html == null || typeof html !== 'string') {
    return '';
  }

  return DOMPurify.sanitize(html);
}

module.exports = { sanitizeHtml };
